import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { NewInputList, NewSelect, NewModal, MainContentPaddingTypes, NewCreatableSelect } from "..";
import { ListStyle_Types, NewSelectHandles, NewInputListHandles } from "../../Definitions";
import { DynamicDataObk, CreatePanelController } from "../../Services";
import { useLcIoOptions } from "../../Containers/FullViewScreens/GlobalScreens/Settings/_Settings/useLcIoOptions";
import NewButton from "../BaseComponents/newButton";

interface addLcModalProps {
  isModalOpen: boolean;
  maintainControllerInfo?: (
    changed?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>,
    deleted?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>,
    created?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>
  ) => void;
  closeModal: () => void;
}

export default function AddLcModal({
  isModalOpen,
  closeModal,
  maintainControllerInfo,
}: addLcModalProps) {
  const { t } = useTranslation();
  const { systemOptions, lanControllerCpuOptions } = useLcIoOptions();
  const inputRef = useRef<NewInputListHandles>(null);
  const creatableSelectRef = useRef<NewSelectHandles>(null);
  const selectRef = useRef<NewSelectHandles>(null);

  const handleCreate = () => {
    // const createdController: CreatePanelController = {}; // Not working af
    const createdController: CreatePanelController = {
    };

    if (inputRef && inputRef.current && inputRef.current.refs.current) {
      createdController.name =
        inputRef.current.refs.current[0].value.toString();
    }

    if (creatableSelectRef && creatableSelectRef.current) {
      createdController.cpu_id =
        creatableSelectRef.current.value.label ?? undefined;
    }

    if (selectRef && selectRef.current) {
      createdController.system_id = selectRef.current.value.id
        ? +selectRef.current.value.id
        : undefined;
    }

    if (inputRef.current) {
      if (!createdController.name) {
        inputRef.current.refs.current[0].setError();
      } else {
        if (maintainControllerInfo) {
          maintainControllerInfo({ data: [createdController] });
          closeModal();
        }
      }
    }
  };
  return (
    <NewModal
      modalState={isModalOpen}
      header={t("devices.newLcBoard", { defaultValue: "new lc board" })}
      predefinedButtons={{
        onClose: closeModal,
      }}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary,
      }}
      mainContent={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "60px",
            marginTop: "25px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <NewInputList
              ref={inputRef}
              headers={[t("devices.boardName", { defaultValue: "board name" })]}
              placeholders={[""]}
              isRequired={[true]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px",
              }}
            />
            <NewCreatableSelect
              ref={creatableSelectRef}
              header={t("devices.cpuId", { defaultValue: "cpu id" })}
              options={lanControllerCpuOptions}
              isSearchable
            />
            <NewSelect
              ref={selectRef}
              header={t("devices.system", { defaultValue: "system" })}
              options={systemOptions}
            />
          </div>
          <NewButton
            content={t("buttons.create", { defaultValue: "create" })}
            onClick={handleCreate}
          />
        </div>
      }
    />
  );
}
